<template>
  <div class="text-xs-center Logview">
     <v-dialog
            v-model="dialog"
            width="500"
    >
    <v-icon
    small
    slot="activator"
    class="mr-3"

    >
     visibility
    </v-icon>
      <v-card >
          <div class="resultContainer py-5 px-2">
            <div class=" text-xs-center ele-size" align-center >
            <v-layout row wrap>

            <v-flex xs6>
             <h4 class="headline text-capitalize font-weight-black">{{getLog.club_name}}</h4>
             <span x2  class=""> Date : {{getLog.club_name}}</span>
             </v-flex>
             <v-flex xs6>
                 <p>Total</p>
                 <p class="display-1">{{getLog.price}}</p>
             </v-flex>
             </v-layout>
              <v-divider ></v-divider>
              <v-layout row wrap class="invoiceTable px-2">
              <v-flex xs12 >
                <table >
                    <tr>
                        <th class="left">Packages</th>
                        <th>Amount</th>
                    </tr>
                    <tr v-for="i in getLog.memberships" :key="i.id">
                        <td v-text="i.name"></td>
                        <td v-text="i.cost"></td>
                    </tr>
                </table>
                </v-flex>
              </v-layout>
               <v-layout>
                <v-flex>
                  <v-btn class="nofication-click  mainBackG">Confirm</v-btn>
                </v-flex>
               </v-layout>
            </div>
          </div>
          </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */
  export default {
      props:["id"],
      name:'LogView',
    data () {
      return {
        dialog: false,
        // getlog:
      }
    },
    created(){

    },

    methods:{
    },
    computed:{
     getLog(){
     }
    }

  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/LogView.vue